export const removeExtraDiv = (htmlValue: Document) => {
  const divElements = htmlValue.querySelectorAll('div')

  divElements.forEach((divElement) => {
    const newP = document.createElement('p')
    while (divElement.firstChild) {
      newP.appendChild(divElement.firstChild)
    }
    divElement.replaceWith(newP)
  })
}
